import { Link } from "react-router-dom";

export function Header({ lang, t, subpage }) {
  const home = lang === "en" ? "/" : "/de";
  const href = (id) => (subpage ? `${home}${id}` : id);
  return (
    <header className="site-header">
      <div className="wrap header">
        <Link to={home} className="logo" data-testid="header-logo">
          <img src="/assets/mezzbridge-logo-400.png" alt="" width="34" height="34" />
          <span>Mezzbridge</span>
        </Link>
        <nav className="nav" data-testid="header-nav">
          <a href={href("#how")} data-testid="nav-how">{t.nav.how}</a>
          <a href={href("#need")} data-testid="nav-need">{t.nav.need}</a>
          <a href={href("#faq")} data-testid="nav-faq">{t.nav.faq}</a>
          <span className="langswitch" data-testid="lang-switch">
            {lang === "en" ? (
              <>
                <span className="lang-active">EN</span>
                <span className="lang-sep">|</span>
                <Link to="/de" className="lang-link" data-testid="lang-switch-de">DE</Link>
              </>
            ) : (
              <>
                <Link to="/" className="lang-link" data-testid="lang-switch-en">EN</Link>
                <span className="lang-sep">|</span>
                <span className="lang-active">DE</span>
              </>
            )}
          </span>
          <a href={href("#contact")} className="btn btn-header" data-testid="header-cta">{t.nav.cta}</a>
        </nav>
      </div>
    </header>
  );
}
